function Logout() {



    return (
        <div className="flex items-center justify-center h-screen bg-inputbox-color text-white">
            <p className="text-lg font-medium">Session Expired!!</p><br />
            <p className="text-lg font-medium">Please Reopen</p>
        </div>
    );
}

export default Logout;
